import 'slick-carousel';
import { createSlides } from './create-slides';

const $sliderHero = $('.slider-hero .slider__slides');

$sliderHero.slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	infinite: true,
	speed: 300,
	autoplay: true,
	autoplaySpeed: 7000,
	adaptiveHeight: true,
	pauseOnHover: true,
	dots: true,
	responsive: [
		{
			breakpoint: 768,
			settings: {
				arrows: false,
				autoplay: false
			}
		}
	]
});

$sliderHero.on('swipe', function(event, slick, direction) {
	stopAutoplay($sliderHero);
});

$(document).on('click', '.slider-hero .slick-prev, .slider-hero .slick-next, .slider-hero .slick-dots', function() {
	stopAutoplay($sliderHero);
});

function stopAutoplay($slider) {
	$slider.slick(
		'slickSetOption',
		{
			autoplay: false
		},
		true
	);
}


// PDP - sliders
const $sliderImagesMain = $('.js-slider-images');
const $sliderThumbsMain = $('.js-slider-thumbs');

$sliderImagesMain.slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  swipe: false,
  infinite: false,
  fade: true,
  asNavFor: '.js-slider-thumbs',
	responsive: [
		{
			breakpoint: 768,
			settings: {
			  dots: true,
			  infinite: true
			}
		}
	]
});

$sliderThumbsMain.slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  infinite: false,
  focusOnSelect: true,
  useTransform: false,
  asNavFor: '.js-slider-images'
});


// popup slider on PDP
function initSlider($sliderHolder, sliderOptions) {
  $sliderHolder.slick(sliderOptions);
}

function initProductsPopupSlider() {
  // Slider thumbs
  const $sliderThumbs = $('.js-slider-thumbs-popup');
  const sliderThumbsOptions = {
    vertical: true,
    focusOnSelect: true,
    dots: false,
    arrows: false,
    arrows: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.js-slider-product-popup'
  };

  // Slider products
  const $sliderProduct = $('.js-slider-product-popup');
  const sliderProductOptions = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    fade: false,
    asNavFor: '.js-slider-thumbs-popup'
  };

  initSlider($sliderProduct, sliderProductOptions);
  initSlider($sliderThumbs, sliderThumbsOptions);

  createSlides($sliderProduct);
  createSlides($sliderThumbs);

  $sliderProduct.on('afterChange', function(event, slick, currentSlide) {
    $sliderProduct.find('.js-slider-product-popup .slick-slide:not(.slick-current) iframe').attr('src', $sliderProduct.find('iframe').attr('src'));
  });

  let resizeTimer;

  $(window).on('resize', function() {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(function() {
      createSlides($sliderProduct);
      createSlides($sliderThumbs);
    }, 150);
  });
}

$('.view_all_images').magnificPopup({
	type: 'inline',

	fixedContentPos: false,
	fixedBgPos: true,

	closeBtnInside: true,
	preloader: false,

	midClick: true,
	removalDelay: 300,

	callbacks: {
		open: function() {
			initProductsPopupSlider();
    }
	}
});

// Product Tabs
var $sliderProductTabs = $('.js-slider-tabs');
var sliderProductTabsOptions = {
  slidesToShow: 6,
  slidesToScroll: 1,
  asNavFor: '.product__details-contents',
  arrows: false,
  dots: false,
  fade: false,
  focusOnSelect: true
};
  
var $sliderProductContents = $('.product__details-contents');
var sliderProductContentsOptions = {
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.js-slider-tabs'
};
initSlider($sliderProductContents, sliderProductContentsOptions);
initSlider($sliderProductTabs, sliderProductTabsOptions);


// WEBPACK FOOTER //
// ../assets/js/sliders.js